import { ClickTrackingInfo } from "@omni/types/components/tracking/tracking-info/click/click.trackingInfo";

import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsMinimumDataset,
    getPageInfo,
    getUserInfo
} from "../GoogleAnalyticsMinimumDataset";

export interface GoogleAnalyticsBannerImpression
    extends GoogleAnalyticsMinimumDataset {
    info: {
        name: string;
        placement: string;
        type: string;
        targeturl: string;
        targetname: string;
    };
}

const getGoogleAnalyticsBannerImpression = (
    data: TypedAnalyticsEvent<ClickTrackingInfo>,
    event: GoogleAnalyticsEvents = GoogleAnalyticsEvents.BannerImpression
): GoogleAnalyticsBannerImpression => {
    const eventData: ClickTrackingInfo = data?.payload.eventData || {};

    return {
        event,
        pageInfo: getPageInfo(data),
        userInfo: getUserInfo(data),
        info: {
            name: eventData.name || "",
            placement: eventData.placement || "",
            type: eventData.type || "",
            targeturl: eventData.targetUrl || "",
            targetname: eventData.targetName || ""
        }
    };
};

export { getGoogleAnalyticsBannerImpression };
